




































































































/* General */
import Vue from 'vue'
import * as routerNames from '@/services/router/router.names'
import logoSrc from '@/assets/img/logos/logo-donedone.svg'
import searchIconSrc from '@/assets/img/icons/search.svg'

/* Mixins */

/* Components */
import AppHeaderGlobalSearch from './components/app-header-global-search/app-header-global-search.vue'
import AppHeaderNotification from './components/app-header-notification.vue'
import AppHeaderGlobalAdd from './components/app-header-global-add.vue'
import AppHeaderDropdownMenu from './components/app-header-dropdown-menu.vue'
import AppHeaderFrillLauncher from './components/app-header-frill-launcher.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'DdAppHeader',

  components: {
    AppHeaderGlobalSearch,
    AppHeaderNotification,
    AppHeaderGlobalAdd,
    AppHeaderDropdownMenu,
    AppHeaderFrillLauncher,
  },

  props: {
    unstickHeader: {
      type: Boolean,
      default: false,
    },
    hideMobileBackButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      RouteAssistant,
      logo: {
        src: logoSrc,
        alt: 'Logo DoneDone',
      },
      logoSize: 32,
      searchIcon: {
        src: searchIconSrc,
        alt: 'Search',
      },
      searchActive: false,
      routerNames,
    }
  },

  computed: {
    accountID(): string {
      return this.$route.params.accountId
    },
    showFullOptions(): boolean {
      return (
        !['xs'].includes(this.$mq) ||
        (['xs'].includes(this.$mq) && !this.searchActive)
      )
    },
    showNav(): boolean {
      if (this.$screen.isTabletOrMobile(this.$mq)) {
        return false
      } else if (['md', 'lg'].includes(this.$mq)) {
        return !this.searchActive
      }
      return true
    },
    reportsUrl(): string {
      return `${process.env.VUE_APP_SERVER_SIDE_APP_URL}/app/${
        this.accountID
      }/reports`
    },
    workflowsUrl(): string {
      return `${process.env.VUE_APP_SERVER_SIDE_APP_URL}/app/${
        this.accountID
      }/workflows`
    },
  },

  methods: {
    isWorkflowsRoute(): boolean {
      return (
        this.isCurrentRoute(routerNames.WORKFLOW_HOME) ||
        this.isCurrentRoute(routerNames.WORKFLOW_DETAIL)
      )
    },
    isPeopleRoute(): boolean {
      return (
        this.isCurrentRoute(routerNames.PEOPLE) ||
        this.isCurrentRoute(routerNames.PEOPLE_CREATE) ||
        this.isCurrentRoute(routerNames.PERSON_DETAIL) ||
        this.isCurrentRoute(routerNames.COMPANY_CREATE)
      )
    },
    isGuestRoute(): boolean {
      return (
        this.isCurrentRoute(routerNames.GUESTS) ||
        this.isCurrentRoute(routerNames.GUESTS_CREATE) ||
        this.isCurrentRoute(routerNames.GUESTS_DETAIL) ||
        this.isCurrentRoute(routerNames.COMPANY_GUESTS_CREATE)
      )
    },
    isCurrentRoute(pathName: string): boolean {
      return pathName.toLowerCase() === this.$route.name
    },
    toggleSearch(val: boolean) {
      this.searchActive = val
      this.$emit('toggle-search', val)
    },
    showSearch() {
      this.toggleSearch(true)
      this.$emit('toggle-search', true)
    },
    hide() {
      if (this.searchActive) {
        this.toggleSearch(false)
      }
    },
    activateLoading() {
      this.$store.set('app/isLoading', true)
    },
  },
})
